<template>
  <v-btn
    small
    flat
    class="ma-0"
    color="primary"
    :disabled="isDefault"
    @click="makeDefault"
  >
    <v-icon small left>{{ isDefault ? 'star' : 'star_border' }}</v-icon>
    {{ isDefault ? 'Default view' : 'Make this my default view' }}
  </v-btn>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    view: {
      type: String,
      required: true,
      validator: v => ['list', 'month'].includes(v),
    },
  },
  computed: {
    ...mapState('userAuth', ['user']),
    isDefault() {
      // null/unset preference means List is the effective default
      return (this.user.defaultCalendarView || 'list') === this.view
    },
  },
  methods: {
    makeDefault() {
      this.$store.dispatch('userAuth/setDefaultCalendarView', this.view)
    },
  },
}
</script>
